embeddedVideoInit('[data-youtube-play-button]', '[data-youtube-parent]', '[data-youtube-container]');
